import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
import GridItem from "../grid/griditem";
import FlexContainer from "../grid/flexcontainer";
import { Button } from "./button";
const toolbarSeparatorClass = css({
    height: "20px",
    width: "1px",
    backgroundColor: getThemeColorVar("typo", "lighter"),
});
export const ToolbarButtons = (props) => {
    return (React.createElement(GridItem, { justifySelf: "end" },
        React.createElement(FlexContainer, { spaceBetween: "lg", "md-align": "center" }, props.buttons
            .map((props, index) => (React.createElement(Button, { key: index * 2, type: "tertiary", icon: props.icon, onClick: props.onClick, title: props.title, disabled: props.disabled, size: "tiny" })))
            .map((button, index, array) => index === array.length - 1
            ? button
            : [
                button,
                React.createElement("span", { key: index * 2 + 1, className: cx(toolbarSeparatorClass) }),
            ]))));
};
export default ToolbarButtons;
//# sourceMappingURL=toolbarbuttons.js.map